import React from "react";
import { observer } from "mobx-react";
import SportStatisticsStore from "@state/stores/offer/statistics/SportStatisticsStore";
import { EventStatsGroup } from "./EventStatsGroup";

export default observer(function GroupedEventStatsChart(props: {
	store: SportStatisticsStore;
}) {
	if (!props.store.filteredMatchStats.groupedMatchStatisticsChartData) {
		return null;
	}

	return (
		<div>
			{props.store.filteredMatchStats.groupedMatchStatisticsChartData.map(
				(group, index) =>
					group.data &&
					group.data.length > 0 && (
						<EventStatsGroup
							key={index}
							index={index}
							statsGroup={group}
						/>
					)
			)}
		</div>
	);
});
